import { selectApplicableCurrencies } from '@/ducks/common/lookup/selectors';
import { selectDefaultCurrencyCode } from '@/ducks/common/selectors';
import { updateValues } from '@/ducks/filters/hooks';
import { selectCurrencyCode } from '@/ducks/filters/selectors';
import { setFilter } from '@/ducks/filters/setters';
import { type AppDispatch, type AppGetState } from '@/store';

export const verifyCurrentCurrencyCode = () => (dispatch: AppDispatch, getState: AppGetState) => {
  const state = getState();
  const currencyCode = selectCurrencyCode(state);
  const currencies = selectApplicableCurrencies(state);
  if (!currencies.some(({ code }) => code === currencyCode)) {
    const defaultCurrencyCode = selectDefaultCurrencyCode(state);
    const searchParams = setFilter.currencyCode(defaultCurrencyCode);
    dispatch(updateValues({ searchParams }));
  }
};
